import { useConnection } from '@/features/connections/connection-context';
import { useCollections } from '@/query/firebase';
import { FirestoreCollection } from '@shared/types';

export interface SidebarProps {
  selectedCollection: string | null;
  onSelectCollection: (collectionId: string) => void;
}

export function useSidebar({ selectedCollection, onSelectCollection }: SidebarProps) {
  const { connectionId } = useConnection();
  const { data: collectionsData, isLoading: loading } = useCollections(connectionId);
  const allCollections = (collectionsData ?? []) as FirestoreCollection[];

  return {
    allCollections,
    loading,
    selectedCollection,
    onSelectCollection,
  };
}
